import { BaseConfig } from '../ServiceConfig';

export interface DiscoveryConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.DiscoveryServiceConfigData';
  url: string;
  channel: string;
  terminal: string;
  stockRequestUrl: string;
  shareUrl: string;
  supportOpenApps: string[];
  isStockRequiredForAddingToCart: boolean;
  isStockDetailVisible: boolean;
}

export const DiscoveryConfigurationFields: (keyof DiscoveryConfiguration)[] = [
  'url',
  'channel',
  'terminal',
  'stockRequestUrl',
  'shareUrl',
  'supportOpenApps',
  'isStockRequiredForAddingToCart',
  'isStockDetailVisible',
];

export const BlankDiscoveryConfiguration: DiscoveryConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.DiscoveryServiceConfigData',
} as DiscoveryConfiguration;
